// Round 3, Lane 3 (R-105 / B-169, blind r2 + r4 priya: the Velaslavasay Panorama was scheduled with no word that it is by
// appointment only). Pure, no imports, so tests/r3_filters_test.ts loads it from Deno.
//
// The listing field: items.vibe.booking = 'appointment' | 'reservation' | 'none' (set by a person or the pipeline; 'none'
// silences a wrong guess). No field: the listing's own words decide (hours text, schedule text, its line, its price line):
// "by appointment", "hourly appointment(s)", "appointment(s) only / required", "reservation(s) required / needed / only",
// "by reservation", "advance reservation / booking required", "timed entry". "Reservations recommended" is not a need.
// vibe is already read for every card shown (poollist DISPLAY_KEYS) and every plan item, so no new column and no migration.
export type Booking = 'appointment' | 'reservation'
export type Bookable = {
  url?: string | null; ticket_url?: string | null; one_line?: string | null; hours_text?: string | null
  schedule_text?: string | null; price_text?: string | null; vibe?: { booking?: unknown } | Record<string, unknown> | null
}

const APPT = /\bby\s+(?:hourly\s+|private\s+|prior\s+)?appointments?\b|\bhourly\s+appointments?\b|\bappointments?\s+(?:only|required|needed|necessary)\b|\b(?:open|visits?|tours?|viewings?)\s+by\s+appointment\b/i
const RESV = /\bby\s+reservations?(?:\s+only)?\b|\breservations?\s+(?:are\s+)?(?:required|needed|necessary|only|essential|a\s+must)\b|\badvance\s+(?:reservations?|booking|tickets?)\s+(?:is\s+|are\s+)?(?:required|needed|necessary)\b|\btimed[-\s]entry\b|\bmust\s+(?:book|reserve)\b/i

/** Does this listing need booking ahead, and which kind? null = no note. */
export function bookingOf(it: Bookable | null | undefined): Booking | null {
  if (!it) return null
  const f = (it.vibe as { booking?: unknown } | null | undefined)?.booking
  if (f === 'appointment' || f === 'reservation') return f
  if (f === 'none') return null
  const t = [it.hours_text, it.schedule_text, it.one_line, it.price_text].filter(Boolean).join(' · ')
  if (!t) return null
  if (APPT.test(t)) return 'appointment'
  if (RESV.test(t)) return 'reservation'
  return null
}
/** Where to book: its ticket page when it has one, else its own page. */
export const bookingLink = (it: Bookable): string | null => it.ticket_url || it.url || null
